export var UnavailabilityReason;
(function (UnavailabilityReason) {
    UnavailabilityReason["SoldOut"] = "soldout";
    UnavailabilityReason["Unavailable"] = "order_delivery_time";
})(UnavailabilityReason || (UnavailabilityReason = {}));
export var UnavailabileVariationReason;
(function (UnavailabileVariationReason) {
    UnavailabileVariationReason["SoldOut"] = "soldout";
    UnavailabileVariationReason["Unavailable"] = "unavailable";
    UnavailabileVariationReason["UnavailableTime"] = "unavailable time";
    UnavailabileVariationReason["UnavailablePlatform"] = "unavailable platform";
    UnavailabileVariationReason["UnavailableDeliveryMethod"] = "unavailable delivery method";
})(UnavailabileVariationReason || (UnavailabileVariationReason = {}));
//# sourceMappingURL=Availability.js.map